import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface CardBodyListItemPropsType {
    variant: DefaultComponentVariantType | null;
}

const setCardBodyListItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-bottom: 4px;
            border-radius: ${theme.star.radius.medium};
        `;
    }
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            height: auto;
            border-radius: ${theme.star.radius.none};
            gap: ${theme.star.gap.medium};

            &:last-of-type: {
                margin-bottom: 0;
            }

            & [class$='RunnerCell'] {
                padding: 0;
            }
        `;
    }
    return css`
        border-bottom: 1px solid ${theme.star.racingNextOff.raceBox.borderColor};
        &:last-of-type {
            border-color: ${theme.star.racingNextOff.raceBox.borderColorTertiary};
        }
    `;
};

export const CardBodyWrapper = withConfig(theme => styled('ul', { label: 'CardBodyWrapper' })<{variant: DefaultComponentVariantType | null}>`
    ${({ variant }):SerializedStyles => variant === DefaultComponentVariantType.TERTIARY
      ? css`
          padding: ${theme.star.padding.xMedium} ${theme.star.padding.xMedium} 0;
          background: ${theme.star.unified.layoutGlobal.bgColor};
          display: flex;
          flex-flow: column;
          gap: ${theme.star.gap.small};

          & + [class$='CardFooterListItem'] {
              border-bottom: none;

              & [class$='ShowMoreLink'] {
                  font-size: ${theme.star.fontSize.xRegular};
                  font-weight: ${theme.star.fontWeight.xMedium};
              }
          }

          &::after {
              content: '';
              display: block;
              border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
              margin-top: ${theme.star.padding.xMedium};
          }
        `
      : css``};
`);

export const CardBodyListItem = withConfig(theme => styled('li', { label: 'CardBodyListItem' })<CardBodyListItemPropsType>`
    height: 48px;
    ${({ variant }): SerializedStyles => setCardBodyListItem(variant, theme)}
    align-items: center;
    background-color: ${theme.star.selectionsGroup.bgColor};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
`);
